import CommonUtil from '../util/CommonUtil';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Adjust path
import { useEffect, useState } from 'react';

const Header: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [logoSrc, setLogoSrc] = useState('/logo.png');
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!window.location.hostname.startsWith('www')) {
      setLogoSrc('/logo-test.png');
    }
  }, []);

  useEffect(() => {
    // Close the navbar when the location changes
    setExpanded(false);
  }, [location]);

  const handleLogout = async () => {
    try {
      await logout();
      CommonUtil.logEvent("logout");
      navigate('/home');
    } catch (error) {
      console.error("로그아웃 실패:", error);
    }
  };

  const handleNavClick = () => {
    setExpanded(false);
  };

  const isLogined = isAuthenticated && user;

  return (
    <Navbar 
      sticky="top" 
      bg="dark" 
      data-bs-theme="dark" 
      expand="lg" 
      className="bg-body-tertiary"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={handleNavClick}>
          <img
            src={logoSrc}
            width="150"
            height="30"
            className="d-inline-block align-top"
            alt="Playball Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {isLogined && (
              <Nav.Link as={Link} to="/dashboard" onClick={handleNavClick}>리그 대시보드</Nav.Link>
            )}
            <Nav.Link as={Link} to="/ranking" onClick={handleNavClick}>선수 랭킹</Nav.Link>
            <Nav.Link as={Link} to="/user-ranking" onClick={handleNavClick}>유저 랭킹</Nav.Link>
            <Nav.Link as={Link} to="/betting" onClick={handleNavClick}>베팅 이벤트</Nav.Link>
            <Nav.Link as={Link} to="/player" onClick={handleNavClick}>선수 명단</Nav.Link>
            <Nav.Link as={Link} to="/guide" onClick={handleNavClick}>게임 가이드</Nav.Link>
            {isLogined ? (
              <>
                <Nav.Link as={Link} to="/my" onClick={handleNavClick}>{user.nickname}</Nav.Link>
                <Nav.Link onClick={() => { handleNavClick(); handleLogout(); }}>로그아웃</Nav.Link>
              </>
            ) : (
              <Nav.Link as={Link} to="/login" onClick={handleNavClick}>로그인</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;


